import { makeStyles, Theme, Box, Typography } from '@material-ui/core';

import RecipientListSelect from './RecipientListSelect';

import { dividerColor } from 'src/data/colors';

const useStyles = makeStyles((theme: Theme) => ({
  deliverySettings: {
    border: `1px solid ${dividerColor}`,
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
  },
  deliverySettingsTitle: {
    textTransform: 'uppercase',
    fontSize: 12,
    marginBottom: theme.spacing(2),
  },
  deliverySettingsBody: {
    fontSize: 16,
    marginBottom: theme.spacing(2),
  },
  deliverySettingsEmail: {
    fontWeight: 500,
    fontSize: 20,
    marginBottom: theme.spacing(2),
  },
  input: {
    marginBottom: theme.spacing(2),
  },
  title: {
    fontSize: 20,
    fontWeight: 500,
    marginBottom: theme.spacing(2),
  },
}));

interface Props {
  email: string;
  handleAddRecipient: (recipientEmails: string[]) => void;
  handleRemoveRecipient: (recipientEmails: string) => void;
  recipients: string[];
  users: string[];
}

const DeliverySettings = ({
  email,
  handleAddRecipient,
  handleRemoveRecipient,
  recipients,
  users,
}: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.deliverySettings}>
      <Typography className={classes.deliverySettingsTitle}>Delivery Settings</Typography>
      <Typography className={classes.deliverySettingsBody}>
        This report will be delivered to your email:
      </Typography>
      <Typography className={classes.deliverySettingsEmail}>{email}</Typography>
      <Typography className={classes.deliverySettingsBody}>
        You can send this report to other people you choose to CC.
      </Typography>
      <Box>
        <RecipientListSelect
          label="CC results to"
          options={users.filter((user) => user !== email)}
          recipients={recipients}
          onRemove={handleRemoveRecipient}
          onAdd={handleAddRecipient}
        />
      </Box>
    </Box>
  );
};

export default DeliverySettings;
